
import * as ipxRuntime$_3XUEesx2jtgL2d7CwMWOmEknaCdM8BkbWuwzNCCq2Co from '/var/lib/jenkins/workspace/train73.pro/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as ipxStaticRuntime$IahbKAIjxIq8sf3bEjch0NJtbPCbw_WJTh8JWglu7ok from '/var/lib/jenkins/workspace/train73.pro/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 480,
    "md": 768,
    "lg": 1024,
    "xl": 1240,
    "xxl": 1440,
    "2xl": 1920
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_3XUEesx2jtgL2d7CwMWOmEknaCdM8BkbWuwzNCCq2Co, defaults: {"modifiers":{"format":"webp"}} },
  ['ipxStatic']: { provider: ipxStaticRuntime$IahbKAIjxIq8sf3bEjch0NJtbPCbw_WJTh8JWglu7ok, defaults: {"modifiers":{"format":"webp"}} }
}
        